import { request } from '../api';
import { HTTP_METHODS } from '../project-types/common/http-types';

export interface SchemeSummary {
  id: string;
  schemeName: string;
}

export interface SchemeTemplate {
  description: string;
  agreementHtml: string;
}

export const fetchSchemeList = async (): Promise<SchemeSummary[]> => {
  const response = await request({ url: '/oto-schemes', method: HTTP_METHODS.GET });
  const schemes: Array<{ id: number | string; schemeName: string }> = response?.data?.schemeArray || [];
  return schemes.map((s) => ({ id: String(s.id), schemeName: s.schemeName }));
};

// The scheme endpoint carries the description; the agreement is served as raw HTML by the terms endpoint.
export const fetchSchemeTemplate = async (schemeId: string): Promise<SchemeTemplate> => {
  const [scheme, terms] = await Promise.all([
    request({ url: `/oto-schemes/${schemeId}`, method: HTTP_METHODS.GET }),
    request({ url: `/oto-schemes/terms/${schemeId}`, method: HTTP_METHODS.GET, responseType: 'text' }),
  ]);

  return {
    description: scheme?.data?.scheme?.campaignDescription || '',
    agreementHtml: typeof terms?.data === 'string' ? terms.data : '',
  };
};
